<template>
    <div class="entity-confirm-action">
        <div class="entity-confirm-action__title">
            <slot></slot>
        </div>

        <div class="entity">
            <div class="entity__title">{{ dealer.name }}</div>

            <div class="entity__list">
                <div class="entity__list-item">
                    <div class="entity__list-label">Марка:</div>
                    <div class="entity__list-value">
                        {{ dealerBrands.join(', ') ?? '-' }}
                    </div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Холдинг:</div>
                    <div class="entity__list-value">{{ dealer.holding_name || '-' }}</div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Юр. наименование:</div>
                    <div class="entity__list-value">{{ dealer.legal_entity_name || '-' }}</div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Код дилера:</div>
                    <div class="entity__list-value">{{ dealer.sap_code }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { DealerListItem } from '@/types/dealer.type.ts';

    const { dealer } = defineProps<{
        dealer: DealerListItem,
    }>();

    const dealerBrands = computed<string[]>(() => {
        const brands: string[] = [];

        if (dealer.is_hyundai_dealer) {
            brands.push('Hyundai');
        }

        if (dealer.is_genesis_dealer) {
            brands.push('Genesis');
        }

        return brands;
    });
</script>
